import { Page } from '.';

export class Promotion {
  title: string;
  type: string;
  image: string;
  status: string;
  firebaseUrl: string = '';
  frequency: string;
  targetType: string;
  triggerID: string;
  targetUrl: string;
  targetID: string;

  triggerPage: Page;
  targetPage: Page;

  testID: string = '';

  constructor(json: any) {
    this.title = json.title;
    this.type = json.type;
    this.image = json.image;
    this.status = json.status;
    this.targetID = json.target_page || json.targetID;
    this.targetUrl = json.target_url;
    this.firebaseUrl = '/' + json.$key;
    this.frequency = json.frequency;
    this.triggerID = json.trigger_page || json.triggerID;
    this.targetType = json.target_type;

    this.generateDynamicId();
  }

  toFirebaseObject(): any {
    let obj: any = {};

    if (this.title) obj.title = this.title;
    if (this.type) obj.type = this.type;
    if (this.image) obj.image = this.image;
    if (this.status) obj.status = this.status;
    if (this.targetUrl) obj.target_url = this.targetUrl;
    if (this.targetID) obj.target_page = this.targetID;
    if (this.firebaseUrl) obj.firebase_url = this.firebaseUrl;
    if (this.frequency) obj.frequency = this.frequency;
    if (this.triggerID) obj.trigger_page = this.triggerID;
    if (this.targetType) obj.target_type = this.targetType;
    return obj;
  }

  generateDynamicId() {
    let validId = this.title;
    validId = validId.replace(/\s+/g, '-');
    validId = validId.replace(/[^a-z0-9\-_\.]|^[^a-z0-9]+/gi, '');
    this.testID = 'promo-' + validId;
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/models/promotion.model.ts